<script lang="ts">
  import { setContext } from 'svelte'
  import type { FlashState } from '#app/lib/components/flash.svelte'
  import DeduplicateHomonyms from '#entities/components/deduplicate/deduplicate_homonyms.svelte'
  import ActorFollowersSection from '#entities/components/layouts/actor_followers_section.svelte'
  import AddToDotDotDotMenu from '#entities/components/layouts/add_to_dot_dot_dot_menu.svelte'
  import SubEntitiesBrowser from '#entities/components/layouts/sub_entities_browser.svelte'
  import Summary from '#entities/components/layouts/summary.svelte'
  import { getSubEntitiesSections, type SubEntitiesBrowserSectionData } from '#entities/components/lib/entities'
  import { runEntityNavigate } from '#entities/lib/document_metadata'
  import type { SerializedEntity } from '#entities/lib/entities'
  import Spinner from '#general/components/spinner.svelte'
  import EntityListingsLayout from '#listings/components/entity_listings_layout.svelte'
  import BaseLayout from './base_layout.svelte'
  import EntityTitle from './entity_title.svelte'
  import Infobox from './infobox.svelte'

  let {
    entity = $bindable(),
  }: {
    entity: SerializedEntity
  } = $props()

  let flash: FlashState | undefined = $state()

  const uri = $derived(entity.uri)
  $effect(() => void runEntityNavigate(entity))

  let sections: SubEntitiesBrowserSectionData[] | undefined = $state()
  // server is already sorting byPublicationDate
  const waitingForSubEntities = $derived(getSubEntitiesSections({ entity })
    .then(res => sections = res)
    .catch(err => flash = err))

  // TODO: index editions
  // setContext('search-filter-types', null)
  setContext('layout-context', 'publisher')
  $effect(() => void setContext('search-filter-claim', `wdt:P123=${uri}`))
</script>

<BaseLayout
  {entity}
  bind:flash
>
  {#snippet entityLayoutMain()}
    <div class="entity-layout">
      <div class="top-section">
        <div>
          <EntityTitle {entity} />
          <Infobox
            claims={entity.claims}
            entityType={entity.type}
          />
          <Summary {entity} />
          <AddToDotDotDotMenu
            {entity}
            {flash}
            align="left"
          />
        </div>
        {#await waitingForSubEntities}
          <Spinner center={true} />
        {:then}
          <div class="publications">
            <SubEntitiesBrowser {sections} />
          </div>
          <!-- Nest listings within SubEntitiesBrowser section to load it at the same time,
          to not have to push it down when SubEntitiesBrowser is displayed -->
          <EntityListingsLayout {entity} />
        {/await}
      </div>
      <ActorFollowersSection uri={entity.uri} />
      <DeduplicateHomonyms {entity} />
    </div>
  {/snippet}
</BaseLayout>

<style lang="scss">
  @import "general/scss/utils";
  .entity-layout{
    align-self: stretch;
    @include display-flex(column, stretch);
    :global(.summary.has-summary){
      margin-block-start: 1em;
    }
  }
  .publications{
    margin-block-start: 1em;
  }
  .top-section{
    :global(.add-to-dot-dot-dot-menu){
      margin-block-start: 1em;
      width: 10em;
    }
  }
</style>
